<ng-container rtBlock="sc-blog-accordion-block">
    <details rtElem="item">
        <summary rtElem="title" qa-dataid="blog-accordion-title">{{ item().title }}</summary>
        <div rtElem="body" [innerHTML]="item().text"></div>
    </details>
</ng-container>
